import backend from "../utils/backend";
import {
  SET_UNAUTHED_SUBSCRIPTIONS,
  SET_UNAUTHED_SUBSCRIPTIONS_SUCCESS,
  SET_UNAUTHED_SUBSCRIPTIONS_ERROR,
} from "../constants/actionTypes";

export const updateUnAuthedSubscriptions = (
  email,
  lists,
  source,
  user_vars
) => {
  return dispatch => {
    dispatch({
      type: SET_UNAUTHED_SUBSCRIPTIONS,
    });

    return backend
      .request({
        method: "POST",
        url: "/readers/unauth-sub/",
        data: {
          email,
          lists,
          source,
          user_vars,
        },
      })
      .then(() => {
        dispatch({
          type: SET_UNAUTHED_SUBSCRIPTIONS_SUCCESS,
        });
      })
      .catch(err => {
        dispatch({
          type: SET_UNAUTHED_SUBSCRIPTIONS_ERROR,
          payload: err,
        });
      });
  };
};
